import { createSlice } from '@reduxjs/toolkit';

// initial state
const initialState = {
	posts: [],
};

// active account slice
export const allUsersSlice = createSlice({
	name: 'posts',
	initialState,
	reducers: {
		setAllPostCategories: (state, action) => {
			state.postCategories = action.payload;
		},
		setPostCatList: (state, action) => {
			state.postCatList = action.payload;
		},
		setAllPostResources: (state, action) => {
			state.postResources = action.payload;
		},
		setPostResourcesList: (state, action) => {
			state.postResourcesList = action.payload;
		},
		setAllPosts: (state, action) => {
			state.posts = action.payload;
		},
		setAllGovNews: (state, action) => {
			state.govNews = action.payload;
		},
		setAllCompSpecNews: (state, action) => {
			state.specificCompNews = action.payload;
		},
	},
});

export const {
	setAllPostCategories,
	setPostCatList,
	setAllPostResources,
	setPostResourcesList,
	setAllPosts,
	setAllGovNews,
	setAllCompSpecNews
} = allUsersSlice.actions;

export default allUsersSlice.reducer;
